import clsx from 'clsx'
import { useState } from 'react'

import { ManualTrackForm, SelectField } from '@fv/client-components'
import { buildTrackStatusOptions, getCurrentSequence } from '@fv/client-core'

import { CarrierSlider } from '@/components/CarrierSlider'
import { useTypeNames } from '@/hooks/useTypeNames'
import type { Opportunity } from '@/types/Opportunity'

import { useUpdateTrackStatus } from './hooks/useUpdateTrackStatus'

interface props {
  opportunity: Opportunity
}

export const MultiStopTrackingList = ({ opportunity }: props) => {
  const {
    bol,
    equipmentRequested,
    loadId,
    locations,
    pickup,
    quotedEquipmentType,
    refNums,
    track,
  } = opportunity

  const { equipmentName } = useTypeNames()
  const [nextSequence, setNextSequence] = useState('')
  const closePanel = () => setNextSequence('')
  const updateTrackStatus = useUpdateTrackStatus(loadId)
  const currentSequence = getCurrentSequence(track)
  const refNumbers = refNums?.filter(n => n.value !== bol?.bolNumber)
  const trackSequence = nextSequence || String(currentSequence)
  const equipmentLabel = equipmentName(
    quotedEquipmentType ?? equipmentRequested.type,
  )

  return (
    <>
      <SelectField
        className={clsx(
          'form-control w-auto',
          track?.currentStatus,
          'form-control--select',
        )}
        name="trackSequence"
        onChange={e => setNextSequence(e.target.value)}
        options={buildTrackStatusOptions(locations)}
        value={trackSequence}
      />

      <CarrierSlider isOpen={!!nextSequence} onClose={closePanel} width="35rem">
        <p className="mb-0">
          BOL# {bol?.bolNumber ?? 'NA'} / Confirmation#{' '}
          {pickup?.confirmationNumber ?? 'NA'} / {equipmentLabel}
          <br />
          {!!refNumbers.length && (
            <span className="text-xs">
              Ref#: {refNumbers.map(n => n.value).join(' / ')}
            </span>
          )}
        </p>
        <hr className="mb-4" />
        <ManualTrackForm
          closeForm={closePanel}
          initialSequence={Number(nextSequence)}
          loading={updateTrackStatus.isPending}
          locations={locations}
          onSave={updateTrackStatus.mutate}
        />
      </CarrierSlider>
    </>
  )
}
